import {useEffect, useRef, useState} from 'react';

const useIntersectionObserver = <T = any>(
  {root = null, rootMargin = '0px', threshold = 0}: IntersectionObserverInit,
  actionHandler: Function,
  callOnlyOnce?: boolean,
  actionAfterPassedViewport?: Function,
) => {
  //   const [entry, updateEntry] = useState({});
  const [node, setNode] = useState<T>(null);

  const observer = useRef(null);

  useEffect(() => {
    if (observer.current) observer.current.disconnect();

    //  if a root parent is given then this will serve as an highlighter to highlight the root
    //  Also root needs to be scrollable parent or else intersection observer has an erroneous nature.
    //  root.style.border = '4px solid #44aa44';

    observer.current = new window.IntersectionObserver(
      ([entry], observer) => {
        if (entry.isIntersecting) {
          actionHandler();
          if (callOnlyOnce) currentObserver.unobserve((node as unknown) as Element);
        }

        if (actionAfterPassedViewport && entry.intersectionRatio == 0) {
          actionAfterPassedViewport();
        }
      },
      {
        root,
        rootMargin,
        threshold,
      },
    );

    const {current: currentObserver} = observer;

    if (node) currentObserver.observe(node);

    return () => currentObserver.disconnect();
  }, [node, root, rootMargin, threshold]);

  return [setNode];
};

export default useIntersectionObserver;
